import React from 'react';
import { ClipboardCheck, Ruler, Wrench } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
import { QuoteQuiz } from '../QuoteQuiz';
export function InstallationCTA() {
  const steps = [{
    icon: Ruler,
    title: '1. Assess',
    description: 'We visit your property to measure and evaluate your electrical/mechanical capacity.'
  }, {
    icon: ClipboardCheck,
    title: '2. Design',
    description: 'We design a custom system that fits your specific needs and budget constraints.'
  }, {
    icon: Wrench,
    title: '3. Install',
    description: 'Our certified team installs your system efficiently with minimal disruption to your life.'
  }];
  return <section id="quote-form" className="py-16 bg-primary/5 md:py-24" data-id="element-484">
      <div className="container mx-auto px-4 md:px-6" data-id="element-485">
        <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-486">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-6" data-id="element-487">
            Book a Site Visit to Confirm Feasibility
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-488">
            Every property is different. A site visit ensures we recommend the
            simplest system that meets your goals—not the most expensive one.
          </p>
        </div>

        {/* 3-Step Process */}
        <div className="grid md:grid-cols-3 gap-6 mb-16 max-w-4xl mx-auto text-left" data-id="element-489">
          {steps.map((step, index) => <Card key={index} className="border-none shadow-md bg-white" data-id="element-490">
              <CardContent className="p-6" data-id="element-491">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4 text-primary" data-id="element-492">
                  <step.icon className="h-6 w-6" data-id="element-493" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2" data-id="element-494">{step.title}</h3>
                <p className="text-sm text-slate-600" data-id="element-495">{step.description}</p>
              </CardContent>
            </Card>)}
        </div>

        {/* Quote Quiz */}
        <div className="max-w-xl mx-auto" data-id="element-496">
          <QuoteQuiz data-id="element-497" />

          <p className="mt-6 text-sm text-center text-slate-500" data-id="element-498">
            No pressure. No obligation. Just a clear plan for your property.
          </p>
        </div>
      </div>
    </section>;
}